import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, Resolve, RouterStateSnapshot } from '@angular/router';
import { Observable, of } from 'rxjs';
import { AuthService } from './auth.service';
import { catchError } from "rxjs/operators";

@Injectable({
    providedIn: 'root'
})
export class QrResolverService implements Resolve<any> {

    constructor(
        private authService: AuthService
    ) { }

    resolve(
        route: ActivatedRouteSnapshot,
        state: RouterStateSnapshot
    ): Observable<any> | Promise<any> | any {
        return this.authService.getGoldfingerConfiguration().pipe(
            catchError((error) => {
                return of(null);
            }),
        );
    }
}
